<!--<div [class.disabled]="disabled || userAccess==false" fxLayout="row" fxFlex="100%" fxLayoutAlign="{{(configData.direction=='rtl' ? 'end end' : ' center')}}" dir="{{(configData.direction ? configData.direction : 'ltr')}}" [formGroup]="frmGroup" [hidden]="this.frmGroup.get(this.configData.name)['hidden']" class="dhl-componentsswitcheslabel-v2 paddingrght_15">
	<div>
		<input [formControlName]="configData?.name" id="{{configData.id}}" class="form-check-input dhl-radio-v2" type="radio" [checked]="frmGroup.get(configData.name).value?frmGroup.get(configData.name).value:configData.checked" [disabled] = "configData.disabled" [required]="configData.required" 
    (change)="onCommonEventHander(configData?.name)">
    <label class="dhl-radio-label-v2">
      {{configData.label | translate}}
      <span *ngIf="configData.required" class="required">*</span>
    </label>
  </div>
</div>-->
<div [class.disabled]="disabled || userAccess==false" fxLayout="row" fxFlex="100%"
  fxLayoutAlign="{{(configData.direction==='rtl' ? 'end end' : ' center')}}"
  dir="{{(configData.direction ? configData.direction : 'ltr')}}" [formGroup]="frmGroup" #formControl
  [hidden]="this.frmGroup.get(this.configData.name)['hidden']" class="dhl-componentsswitcheslabel-v2 paddingrght_15"
  [class.dhl-radio-component]="configData?.showMsgIfNull">
  <mat-radio-group [required]="$safeNavigationMigration(configData?.required)" [(ngModel)]="checkedBtnVal" name="{{configData.name}}" [formControlName]="$safeNavigationMigration(configData?.name)" class="dhl-radio-v2"
      [class.radio-align-vertical]="configData?.isVertical"
      [class.radio-grp-border]="radiobuttons.length && configData?.showMsgIfNull">   
    <mat-radio-button class="dhl-radio-btn-v2" *ngFor="let radiobtn of radiobuttons"
      [checked]="radiobtn.value == this.frmGroup.get(this.configData.name).value" [value]="radiobtn.value"
       (change)="onRadioBtnChange($event,$event.value,radiobtn.displayValue)"
       title="{{radiobtn?.displayValue || configData.placeHolder}}">
      {{radiobtn?.displayValue}} 
      <span *ngIf="radiobtn?.infoText">
        <img src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,2260,24,24))"
          class="info-icon" type="image/svg+xml" [matTooltip]="radiobtn.infoText" matTooltipClass="custom-tooltip"/>
      </span>
    </mat-radio-button>
    <app-generic-warning-message *ngIf="configData?.warningText && configData?.warningText.showText" [configData]="configData"></app-generic-warning-message>
      <div class="form-field-error" *ngIf="(frmGroup.get(configData.name).errors) && (frmGroup.get(configData.name).touched)">
        <span class="error-icon">
            <img class="dhl-input-error-icon"
                src="/assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,60,24,24))">
        </span>
        <span class="error-text">
            <span *ngIf="frmGroup.get(configData.name).errors.required">Required</span>
        </span>
    </div>
    <div *ngIf="!radiobuttons.length && configData?.showMsgIfNull">No Saved Search</div>
  </mat-radio-group>
  
</div>